<header-topbar [currentPage]="this.currentPage" />
<sidebar-asidebar />

<main class="wrapper">
  <ng-content></ng-content>
</main>

<notifications-alerts />